import { isDefined } from "@omni/utils/helper.utils";

import {
    SearchConfiguration,
    SearchResults
} from "@/redux/modules/value/search/search.types";
import { mergeHierarchicalFacetsTransformer } from "@/services/bffSearch/responseTransformers/mergeHierarchicalFacets.transformer";
import {
    SearchComponent,
    SearchComponentEnum
} from "@/utils/search/types/searchComponent";
import { SearchComponentStateMap } from "@/utils/search/types/searchState";

export type BffSearchResponseTransformer<
    TSearchComponent extends SearchComponentEnum
> = (
    searchComponentState: SearchComponentStateMap[TSearchComponent],
    searchConfiguration: SearchConfiguration
) => SearchComponentStateMap[TSearchComponent];

const responseTransformersMap: Partial<{
    [TKey in SearchComponentEnum]: BffSearchResponseTransformer<TKey>;
}> = {
    [SearchComponent.PRODUCT_FACETS]: mergeHierarchicalFacetsTransformer
};

const getTransformer = <TSearchComponent extends SearchComponentEnum>(
    component: TSearchComponent
) =>
    responseTransformersMap[
        component
    ] as BffSearchResponseTransformer<TSearchComponent>;

const applyResponseTransformers = (
    searchResults: SearchResults,
    searchConfiguration: SearchConfiguration
): SearchResults =>
    searchResults
        .map((searchResult) => {
            const transformer = getTransformer(searchResult.component);
            if (!transformer) return searchResult;
            return transformer(searchResult, searchConfiguration);
        })
        .filter(isDefined);

export { applyResponseTransformers };
